import { render, staticRenderFns } from "./LearnRenderer.vue?vue&type=template&id=0779c742&"
import script from "./LearnRenderer.vue?vue&type=script&lang=js&"
export * from "./LearnRenderer.vue?vue&type=script&lang=js&"
import style0 from "./LearnRenderer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports